export default __webpack_public_path__ + "static/media/20.f0843d26.jpeg";